import { useMemo } from 'react';
import { READ_ONLY } from 'customer-data-objects/property/AccessLevel';
import { isReadOnly } from 'customer-data-objects/property/PropertyIdentifier';
import { isReadOnlyBillableSubscriptionProperty } from '../../v2/utils/identifiers';
export const useIsPropertyReadOnly = (objectTypeId, propertyDefinition, accessLevel, readOnly) => {
  return useMemo(() => {
    if (accessLevel === READ_ONLY || Boolean(readOnly)) {
      return true;
    }
    if (isReadOnlyBillableSubscriptionProperty(objectTypeId, propertyDefinition)) {
      return true;
    }
    return isReadOnly(propertyDefinition);
  }, [objectTypeId, propertyDefinition, accessLevel, readOnly]);
};